import React from "react";
import styles from "./login.module.css";
import { useHistory } from "react-router-dom";
import { Typography, Form, Input, Button, Row, Col, Alert, Image } from "antd";
import { ReactComponent as LoginBanner } from "../../assets/img/login-banner.svg";
import loginBackground from "../../assets/img/loginBackground.jpg";
import logo from "../../assets/img/kartax.png";
import { authService } from "../../service/auth";
const { Title, Text } = Typography;

const Login = () => {
  const [isError, setIsError] = React.useState(false);
  const history = useHistory();

  const onSubmit = async (values) => {
    setIsError(false);
    authService
      .login(values.email, values.password)
      .then(() => history.push("/"))
      .catch(() => setIsError(true));
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleForgotPassword = () => {
    history.push("/forgot-password");
  };

  return (
    <Row
      style={{
        display: "flex",
        height: "100vh",
        backgroundImage: `url(${loginBackground})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Col span={24} className={styles.panel}>
        <div
          style={{
            borderRadius: 5,
            overflow: "hidden",
            margin: "auto",
            width: "80%",
            maxWidth: "500px",
          }}
        >
          <div className={styles.content}>
            <Row
              style={{
                backgroundColor: "#000",
                color: "white",
                padding: "0.5rem 1rem",
              }}
            >
              <Image src={logo} height={20} width={20} preview={false} />
              <Col style={{ marginLeft: "1rem" }}>LOGIN</Col>
            </Row>
            <div style={{ padding: "1rem 1.5rem 0.1rem 1.5rem" }}>
              {isError && (
                <Alert
                  style={{ margin: "0.5rem 0" }}
                  message="Username or Password not found."
                  type="error"
                />
              )}
              <Form
                layout="vertical"
                initialValues={{ remember: true }}
                onFinish={onSubmit}
                onFinishFailed={onFinishFailed}
              >
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    {
                      type: "email",
                      message: "The input is not valid E-mail!",
                    },
                    {
                      required: true,
                      message: "Please input your email!",
                    },
                  ]}
                >
                  <Input size="large" placeholder="Email" />
                </Form.Item>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    { required: true, message: "Please input your password!" },
                  ]}
                >
                  <Input.Password size="large" placeholder="Password" />
                </Form.Item>
                <Form.Item>
                  <div className={styles.buttonContainer}>
                    <Button type="link" onClick={handleForgotPassword}>
                      Forgot your password?
                    </Button>
                    <Button type="primary" htmlType="submit" size="large">
                      Submit
                    </Button>
                  </div>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default Login;
